import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import { getAssets } from "@unisearch/helpers";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import styles from "./mentor_box.module.scss";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });

const MentorGridBox = (props) => {
  const [isOpen, setOpen] = useState(false);
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();

  const viewDetails = () => {
    if (profileInfo && profileInfo.userTypeSlug) {
      router.push(`/app/student/counsellor/${props?.id}`);
    } else {
      systemActions.setReturnUrl(router.asPath);
      return router.push({ pathname: "/signin" });
    }
  };

  return (
    <>
      <div
        className={`${styles.mentor_list_item} ${
          props.border ? styles.border : ""
        }`}
      >
        <div className={styles.mentor_avatar}>
          <img
            src={props.avatar || getAssets("assets/images/avatar.png")}
            alt="avatar"
          />

          {process.env.NEXT_PUBLIC_COMPONENT_ISHIDDEN !== "true" ? (
            <PlayButtonWithRipple
              colorOrange
              style={{ transform: "scale(.4)", top: "59%", left: "55%" }}
              onClick={() => setOpen(true)}
            />
          ) : (
            ""
          )}

          {/* <img
          className={styles.mark}
          src={getAssets("assets/tick.png")}
          alt="avatar"
        /> */}
        </div>

        <h5 className={styles.mentor_name}>{props?.name}</h5>
        <p>
          {/*{props?.courseName} <br />*/}
          {props?.country}
          {/* Proffesioal Graphic Designer at University Of Sheffield, London */}
        </p>
        {/* <p className="font-xsmall">{props?.type || "Type"}</p> */}
        <button
          onClick={viewDetails}
          className={`btn btn-secondary ${styles.mentor_btn}`}
        >
          View Profile
        </button>
      </div>

      <ModalVideo
        channel="custom"
        autoplay
        isOpen={isOpen}
        url="https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4"
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default MentorGridBox;
